export default "__VITE_ASSET__BZU9PlAB__"